import UploadModal from 'documents/containers/modal/DocumentUploadModal';
import FolderDeleteModal from 'documents/containers/modal/FolderDeleteModal';
import FolderCreateModal from 'documents/containers/modal/FolderCreateModal';
import FolderEditModal from 'documents/containers/modal/FolderEditModal';
import DocumentEditModal from 'documents/containers/modal/DocumentEditModal';
import DocumentDeleteModal from 'documents/containers/modal/DocumentDeleteModal';
import UserEditModal from 'admin/users/containers/modal/UserEditModal';
import UserDeleteModal from 'admin/users/containers/modal/UserDeleteModal';
import UserCreateModal from 'admin/users/containers/modal/UserCreateModal';
import TagEditModal from 'admin/tags/containers/modal/TagEditModal';
import TagDeleteModal from 'admin/tags/containers/modal/TagDeleteModal';
import TagCreateModal from 'admin/tags/containers/modal/TagCreateModal';
import SpaceEditModal from 'admin/spaces/containers/modal/SpaceEditModal';
import SpaceDeleteModal from 'admin/spaces/containers/modal/SpaceDeleteModal';
import SpaceCreateModal from 'admin/spaces/containers/modal/SpaceCreateModal';
import RoleCreateModal from 'admin/roles/containers/modal/RoleCreateModal';
import RoleEditModal from 'admin/roles/containers/modal/RoleEditModal';
import RoleDeleteModal from 'admin/roles/containers/modal/RoleDeleteModal';
import DashboardDeleteModal from 'admin/defaultDashboards/containers/modal/DashboardDeleteModal';
import FileExplorerBulkDeleteModal from 'documents/containers/modal/FileExplorerBulkDeleteModal';
import DocumentShareModal from 'documents/containers/modal/DocumentShareModal';
import DashboardEditModal from 'admin/defaultDashboards/containers/modal/DashboardEditModal';
import DashboardCreateModal from 'admin/defaultDashboards/containers/modal/DashboardCreateModal';
import DocumentEditDefaultFavoritesModal
  from 'documents/containers/modal/DocumentEditDefaultFavoritesModal';
import MyUserSecuritySettingsModal from 'auth/containers/modal/MyUserSecuritySettingsModal';
import SearchModal from 'search/containers/modal/SearchModal';
import DocumentViewModal from 'documents/containers/modal/DocumentViewModal';
import OfflineDocumentViewModal from 'offline/containers/modal/OfflineDocumentViewModal';
import ContactImportModal from 'contacts/containers/modal/ContactImportModal';
import ContactCreateModal from 'contacts/containers/modal/ContactCreateModal';
import ContactEditModal from 'contacts/containers/modal/ContactEditModal';
import ContactDeleteModal from 'contacts/containers/modal/ContactDeleteModal';
import MyContactEditModal from 'contacts/containers/modal/MyContactEditModal';
import DocumentCacheOfflineModal from 'offline/containers/modal/DocumentCacheOfflineModal';
import DocumentCacheOfflinePasswordModal
  from 'offline/containers/modal/DocumentCacheOfflinePasswordModal';
import OfflineChangesSyncModal from 'offline/containers/modal/OfflineChangesSyncModal';
import ChangePasswordModal from 'auth/containers/modal/ChangePasswordModal';
import MailingListCreateModal from 'admin/mailingLists/containers/modal/MailingListCreateModal';
import MailingListEditModal from 'admin/mailingLists/containers/modal/MailingListEditModal';
import MailingListDeleteModal from 'admin/mailingLists/containers/modal/MailingListDeleteModal';
import { cacheDocumentsOfflineAbort } from '../offline';

const modalComponents = {
  CONTACT_CREATE: ContactCreateModal,
  CONTACT_EDIT: ContactEditModal,
  CONTACT_DELETE: ContactDeleteModal,
  CONTACT_IMPORT: ContactImportModal,
  DASHBOARD_CREATE_MODAL: DashboardCreateModal,
  DASHBOARD_EDIT_MODAL: DashboardEditModal,
  DASHBOARD_DELETE_MODAL: DashboardDeleteModal,
  DOCUMENT_CACHE_OFFLINE: DocumentCacheOfflineModal,
  DOCUMENT_CACHE_OFFLINE_PASSWORD: DocumentCacheOfflinePasswordModal,
  DOCUMENT_UPLOAD: UploadModal,
  DOCUMENT_EDIT: DocumentEditModal,
  DOCUMENT_DELETE: DocumentDeleteModal,
  DOCUMENT_SHARE: DocumentShareModal,
  DOCUMENT_VIEW: DocumentViewModal,
  DOCUMENT_DEFAULT_FAVORITES_EDIT: DocumentEditDefaultFavoritesModal,
  FILE_EXPLORER_BULK_DELETE: FileExplorerBulkDeleteModal,
  FOLDER_CREATE: FolderCreateModal,
  FOLDER_EDIT: FolderEditModal,
  FOLDER_DELETE: FolderDeleteModal,
  MAILING_LIST_CREATE: MailingListCreateModal,
  MAILING_LIST_EDIT: MailingListEditModal,
  MAILING_LIST_DELETE: MailingListDeleteModal,
  MY_CONTACT_EDIT: MyContactEditModal,
  MY_SECURITY_SETTINGS: MyUserSecuritySettingsModal,
  OFFLINE_DOCUMENT_VIEW: OfflineDocumentViewModal,
  OFFLINE_CHANGES_SYNC: OfflineChangesSyncModal,
  ROLE_CREATE: RoleCreateModal,
  ROLE_EDIT: RoleEditModal,
  ROLE_DELETE: RoleDeleteModal,
  SEARCH: SearchModal,
  SPACE_CREATE: SpaceCreateModal,
  SPACE_EDIT: SpaceEditModal,
  SPACE_DELETE: SpaceDeleteModal,
  TAG_CREATE: TagCreateModal,
  TAG_EDIT: TagEditModal,
  TAG_DELETE: TagDeleteModal,
  USER_CREATE: UserCreateModal,
  USER_EDIT: UserEditModal,
  USER_DELETE: UserDeleteModal,
  CHANGE_PASSWORD: ChangePasswordModal,
};

export const modalProps = {
  DASHBOARD_EDIT_MODAL: {
    width: '100%',
    className: 'fullscreen',
  },
  DASHBOARD_CREATE_MODAL: {
    width: '100%',
    className: 'fullscreen',
  },
  DOCUMENT_CACHE_OFFLINE: {
    onCloseActionToDispatch: cacheDocumentsOfflineAbort,
  },
  DOCUMENT_VIEW: {
    width: '100%',
    className: 'fullscreen',
  },
  OFFLINE_DOCUMENT_VIEW: {
    width: '100%',
    className: 'fullscreen flexModal',
  },
  SEARCH: {
    width: '100%',
    shouldFocusAfterRender: false,
  },
};

export default modalComponents;
